import React from "react";

const PartnerHero = ({ data }) => {
  return (
    <>
      <div
        className="partner_hero"
        style={{
          backgroundImage: `url(https://staging-cms-main.ipurvey.com${data?.image_section?.image.url})`,
        }}
      >
        <div>
          <h2>{data?.image_section?.title}</h2>
          <p>{data?.image_section?.description}</p>
          <button className="get_api">
            {data?.image_section?.button_text}
          </button>
        </div>
      </div>
    </>
  );
};

export default PartnerHero;
